import { inject, injectable, singleton } from "tsyringe";
import { ExtensionContext } from "../../common/models/extension-config";
import { Module } from "../../common/module";
import * as html2canvas from 'html2canvas';
import { CommonModule } from "../common.module";

@singleton()
export class ScreenshotModule extends Module {
    public name: string = 'ScreenshotModule';
    public acceptedLicenseFlags: string[] = [];
    public shouldRun(context: ExtensionContext): boolean { return false; }
    constructor(@inject(CommonModule) private common: CommonModule) {
        super([common]);
    }
    public async run(): Promise<void> {
    }

    /**
     Takes a screenshot and returns the Data URL
     */
    public async takeScreenshot(element: HTMLElement, maxRetries: number = 1, retryIntervalMs: number = 1000): Promise<string> {
        let curTry = 0;
        while (true) {
            curTry++;
            try {
                return this._takeScreenshot(element);
            } catch (e) {
                if (curTry >= maxRetries) {
                    this.log.w(`Failed to take a screenshot after ${maxRetries} tries`);
                    throw e;
                } else {
                    await this.common.wait(retryIntervalMs);
                }
            }
        }
    }

    private async _takeScreenshot(element: HTMLElement): Promise<string> {
        const screenshot = await html2canvas.default(element, {
            allowTaint: true,
            backgroundColor: undefined,
            imageTimeout: 10000,
            useCORS: true,
            // height: element.scrollHeight,
            // width: element.scrollWidth,
            // scale: 1,
            // scrollX: 0,
            // scrollY: 0,
            // windowHeight: window.outerHeight,
            // windowWidth: window.outerWidth,
            // x: 0,
            // y: 0,
            logging: false,
            // onclone: (doc, el) => {
            //     const style = doc.createElement('script');
            //     style.appendChild(document.createTextNode("* { letter-spacing: '0px'; }"));
            //     doc.head.appendChild(style);
            // } 
        });
        return screenshot.toDataURL("image/png");
    }
}